import React, { PureComponent } from "react";
import { GenericEditPanel } from "com-gyf-webcore-userinterfacecomponents";

class FormaPagoSucursal extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            data: {
                cuentaBancariaSucursalId: props.data.CuentaBancariaSucursalId,
                cuentaBancariaSucursalCodigo: props.data.CuentaBancariaSucursalCodigo
            },
            dataOriginal: {
                cuentaBancariaSucursalId: props.dataCompleto.cuentaDatosOriginal.CuentaBancariaSucursalId,
                cuentaBancariaSucursalCodigo: props.dataCompleto.cuentaDatosOriginal.CuentaBancariaSucursalCodigo,
            },
            novedades: (props.dataCompleto.novedadesCuentaDatos || []).filter(n => n.NovedadCampoCodigo == props.codigoNovedad),
            sucursales: props.data.accountData.GET_ALL_SUCURSAL
        }

        this.actualizarNovedadEstado = this.actualizarNovedadEstado.bind(this);
    }
    /**
     * 
     * @param {any} novedad
     * @param {any} estadoId
     * @param {any} entidadId
     */
    actualizarNovedadEstado(novedad, estadoId, entidadId) {
        this.props.actualizarNovedadEstado(novedad.Id, estadoId, this.props.codigoNovedad, novedad.NovedadTipoId, entidadId)
    }
    /**
     * 
     * @param {any} event
     */
    selectCombo(event) {
        const { target } = event;
        const index = target.selectedIndex;
        const codigo = target.options[index].dataset.codigo;

        this.props.selectCombo(1, this.props.codigoNovedad, target.value, codigo)
    }
    /**
     * 
     * @param {any} nextProps
     */
    componentWillReceiveProps(nextProps) {
        this.state.data = {
            cuentaBancariaSucursalId: nextProps.data.CuentaBancariaSucursalId,
            cuentaBancariaSucursalCodigo: nextProps.data.CuentaBancariaSucursalCodigo
        }

        this.state.novedades = (nextProps.dataCompleto.novedadesCuentaDatos || []).filter(n => n.NovedadCampoCodigo == nextProps.codigoNovedad);
    }
    /**
     * 
     * @param {any} nextProps
     * @param {any} nextState
     */
    //shouldComponentUpdate(nextProps, nextState) {
    //    return (nextProps.dataCompleto.componenteSeleccionado == nextProps.codigoNovedad);
    //}
    /**
     * 
     */
    render() {
        const { codigoNovedad, data, dataCompleto } = this.props;
        const { esNovedadEditada, sucursalesCuentas } = dataCompleto;

        const estaEditada = esNovedadEditada.find(x => x.campoCodigo == codigoNovedad).editado;

        let cuentaBancariaSucursalIdId = (this.state.data.cuentaBancariaSucursalId || 0);
        let cuentaBancariaSucursalIdDescripcion = "Sin especificar";
        let novedad = undefined;

        if (this.state.novedades && this.state.novedades.length > 0) {
            /*Busco el max id de las novedades generadas por la sucursarl de la cuenta*/
            const novedadId = Math.max(...this.state.novedades.map(n => n.Id));
            /*Obtengo esa novedad*/
            novedad = this.state.novedades.find(n => n.Id == novedadId);

            if (novedad) {
                if (estaEditada == false) {
                    cuentaBancariaSucursalIdId = novedad.ValorNovedad;
                }

                novedad.ValorAnteriorFormateado = "Sin especificar";
            }
        }
        /*busco las descripciones para las novedades*/
        this.state.sucursales.forEach(s => {
            if (s.Id == cuentaBancariaSucursalIdId) {
                cuentaBancariaSucursalIdDescripcion = s.Descripcion;
            }

            if (novedad) {
                if (s.Id == novedad.ValorAnterior) {
                    novedad.ValorAnteriorFormateado = s.Descripcion;
                }
            }
        });

        let componenteSucursalCuenta = (
            <select className="form-control default-select" value={cuentaBancariaSucursalIdId} onChange={this.selectCombo.bind(this)}>
                <option value="0">Seleccione...</option>
                {(sucursalesCuentas || []).map((sucu, index) => {
                    return (
                        <option value={sucu.Id} key={"sucursal-option-" + index} data-codigo={sucu.Codigo}>
                            {sucu.Descripcion}
                        </option>
                    );
                })}
            </select>
        );

        const error = ((cuentaBancariaSucursalIdId == 0) || ((sucursalesCuentas || []).length == 0));

        return (
            <GenericEditPanel
                componente={componenteSucursalCuenta}
                cuenta={data}
                error={error}
                novedad={novedad}
                permisoUsuario={dataCompleto.funcionesDelUsuario}
                seEstaEditando={dataCompleto.seEstaEditando}
                textPanel={cuentaBancariaSucursalIdDescripcion}
                title="Sucursal de la cuenta"
                value={cuentaBancariaSucursalIdId}

                aceptChanges={(value) => this.props.guardarNovedad(value)}
                confirmarNovedad={() => this.actualizarNovedadEstado(novedad, 2, data.CuentaTarjetaId)}
                changeEditMode={(value) => this.props.estadoEdicion(value, this.props.codigoNovedad)}
                denegarNovedad={() => this.actualizarNovedadEstado(novedad, 3, data.CuentaTarjetaId)}
                mostrarModificaciones={this.props.mostrarModal}
                revert={this.props.cancelar} />
        );
    }
}

export default FormaPagoSucursal;